import Sticky from 'react-stickynode';

import { Box } from '@hivebrite/design-system/Box';
import { Container } from '@hivebrite/design-system/Container';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import {
  BLOCKS,
  BlockWrapper,
} from 'hb-react/frontoffice/components/BlocksRenderer/shared';
import Grid, { Row, Col } from 'hb-react/shared/components/DesignSystem/Grid';
import useDisplayNavigationDropShadow from 'hb-react/shared/hooks/theme/useDisplayNavigationDropShadow';
import useOutboxedFontTheme from 'hb-react/shared/hooks/theme/useOutboxedFontTheme';
import ThemeProvider from 'hb-react/style/ThemeProvider';

import TemplateContainer from '../common/TemplateContainer';
import { DEFAULT_ZONE } from '../utils';

const ZONE_IDS = {
  appHeader: 'appHeader',
  left: 'left',
  empty: 'empty',
};

const DEFAULT_ZONES = {
  appHeader: [BLOCKS.appHeader.id],
  left: [BLOCKS.headerControls.id, BLOCKS.filters.id, BLOCKS.tags.id],
  empty: [BLOCKS.emptyContent.id],
};

const TwoColumnsTemplate = ({
  hasFilters,
  offsetRightZone,
  topicId,
  variant,
  zones,
}) => {
  const displayNavigationDropShadow = useDisplayNavigationDropShadow();
  const outboxedFontTheme = useOutboxedFontTheme();
  const breakpoint = useBreakpoint();

  return (
    <TemplateContainer id="two-columns-template">
      {!topicId && (
        <BlockWrapper
          withShadow={
            displayNavigationDropShadow && variant !== 'max' && hasFilters
          }
        >
          {zones[ZONE_IDS.appHeader]}
        </BlockWrapper>
      )}
      <Container height="auto" display="block" pb={6}>
        <Grid rowGap={0}>
          <Row>
            <Col width={{ _: 1, l: 4 / 12, xl: 3 / 12 }}>
              {zones[ZONE_IDS.left] ? (
                <Sticky
                  enabled={['l', 'xl'].includes(breakpoint)}
                  top="header"
                  bottomBoundary="#two-columns-template"
                >
                  <ThemeProvider
                    theme={outboxedFontTheme.themeName}
                    fontBrightness={outboxedFontTheme.fontBrightness}
                  >
                    <Box pb={5} flexDirection="column">
                      {zones[ZONE_IDS.left].map((block, index) => (
                        <BlockWrapper
                          key={index}
                          mt={6}
                          $emptyStyle={{ marginTop: 0 }}
                        >
                          {block}
                        </BlockWrapper>
                      ))}
                    </Box>
                  </ThemeProvider>
                </Sticky>
              ) : null}
            </Col>
            <Col
              offset={{ _: 0, xl: offsetRightZone ? 1 / 12 : 0 }}
              width={{ _: 1, l: 8 / 12, xl: offsetRightZone ? 8 / 12 : 9 / 12 }}
            >
              {zones[DEFAULT_ZONE]?.map((block, index) => (
                <BlockWrapper key={index} mt={6} $emptyStyle={{ marginTop: 0 }}>
                  {block}
                </BlockWrapper>
              ))}
              {zones[ZONE_IDS.empty] && (
                <BlockWrapper mt={8} mb={10}>
                  {zones[ZONE_IDS.empty]}
                </BlockWrapper>
              )}
            </Col>
          </Row>
        </Grid>
      </Container>
    </TemplateContainer>
  );
};

export default {
  id: 'two_columns',
  zones: DEFAULT_ZONES,
  component: TwoColumnsTemplate,
};
